import { render, staticRenderFns } from "./activityCategorySelectGoods.vue?vue&type=template&id=1dddee16&scoped=true"
import script from "./activityCategorySelectGoods.vue?vue&type=script&lang=js"
export * from "./activityCategorySelectGoods.vue?vue&type=script&lang=js"
import style0 from "./activityCategorySelectGoods.vue?vue&type=style&index=0&id=1dddee16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dddee16",
  null
  
)

export default component.exports